/**
 * Payment Methods API
 * Domain API via HTTP transport (apiTransport) to the backend /api RPC.
 */

import { PaymentMethod } from '@repo/shared-types';
import { apiTransport as router } from './transport';
import { getContext } from './core';

export const paymentMethodsApi = {
  list: async (tenantId?: string) => {
    const context = getContext();
    return router.get<PaymentMethod[]>(
      `/payment-methods${tenantId ? `?tenantId=${tenantId}` : ''}`,
      context,
    );
  },
  get: async (id: string) => router.get<PaymentMethod>(`/payment-methods/${id}`),
  create: async (method: Omit<PaymentMethod, 'id' | 'createdAt' | 'updatedAt'>) => {
    const context = getContext();
    return router.post<PaymentMethod>('/payment-methods', method, context);
  },
  update: async (id: string, updates: Partial<PaymentMethod>) => {
    const context = getContext();
    return router.patch<PaymentMethod>(`/payment-methods/${id}`, updates, context);
  },
  delete: async (id: string) => {
    const context = getContext();
    return router.delete<{ success: boolean }>(`/payment-methods/${id}`, context);
  }
};

